import { Component } from '@angular/core';
import {DecimalPipe, NgForOf, NgIf, NgStyle} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import { AVAILABLE_INDUSTRIES_DATASTRUCT } from '../ListConfiguration/InfoConverstion';
import {BreadcrumbHeaderComponent} from '../../LandingPage/NavigationMenu/page-headline/page-headline.component';

@Component({
  selector: 'app-industryoverview',
  standalone: true,
    imports: [
        NgStyle,
        FormsModule,
        NgForOf,
        RouterLink,
        NgIf,
        DecimalPipe,
        BreadcrumbHeaderComponent
    ],
  templateUrl: './industryoverview.component.html',
  styleUrl: './industryoverview.component.scss'
})
export class IndustryoverviewComponent {
  searchTerm: string = '';
  columns: number = 4;
  sortDirection: 'az' | 'za' | 'len-asc' | 'len-desc' = 'az';
  sortedBranchen = [...AVAILABLE_INDUSTRIES_DATASTRUCT];
  constructor() {
    this.sortBranchen();
  }

  sortBranchen() {
    this.sortedBranchen = [...AVAILABLE_INDUSTRIES_DATASTRUCT];
    switch (this.sortDirection) {
      case 'az':
        this.sortedBranchen.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'za':
        this.sortedBranchen.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case 'len-asc':
        this.sortedBranchen.sort((a, b) => a.rowCount - b.rowCount);
        break;
      case 'len-desc':
        this.sortedBranchen.sort((a, b) => b.rowCount - a.rowCount);
        break;
    }
  }

  get totalRowCount() {
    return AVAILABLE_INDUSTRIES_DATASTRUCT.reduce((sum, b) => sum + b.rowCount, 0);
  }

  get filteredBranchen() {
    let result = AVAILABLE_INDUSTRIES_DATASTRUCT.filter(b =>
        !this.searchTerm ||
        b.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    result = [...result].sort((a, b) => {
      if (this.sortDirection === 'az') {
        return a.name.localeCompare(b.name);
      }
      return b.name.localeCompare(a.name);
    });


    return result;
  }

  protected readonly INDUSTRY_OVERVIEW_STATIC_OBJECTS = AVAILABLE_INDUSTRIES_DATASTRUCT;
}
